import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_MINUTE } from 'CorePackage/MainModule/constants/dateFormats';

import { parseErknmValue } from './parseErknmValue';
import { IErknmPeriodExtension } from '../interfaces/IErknmPeriodExtension';

export const getPeriodExtension = (
  passportData: IKnmPreview | undefined,
  erknmField: 'pmErknm' | 'inspectionErknm',
) => {
  const periodExtensions: IErknmPeriodExtension[] = [];

  passportData?.[erknmField]?.events?.forEach(item => {
    if (item.periodExtension) {
      const eventValue = item.event?.value && parseErknmValue(item.event.value);

      const addedPeriodExtension: IErknmPeriodExtension = {
        ...item.periodExtension,
        decisionDateTime:
          item.periodExtension?.decisionDateTime &&
          formatDate({ date: item.periodExtension.decisionDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE }),
        event: eventValue && eventValue.title,
      };

      periodExtensions.push(addedPeriodExtension);
    }
  });

  periodExtensions.sort((a, b) => {
    return a.dateCreate && b.dateCreate ? new Date(a.dateCreate).valueOf() - new Date(b.dateCreate).valueOf() : 0;
  });

  return periodExtensions;
};
